import { Component, input, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'boolean-selector',
  standalone: false,
  templateUrl: './boolean-selector.component.html',
  styleUrl: './boolean-selector.component.scss'
})
export class BooleanSelectorComponent {
  public control = input.required<FormControl>();
  @Input() question: string;
  @Input() tooltipText: string | undefined;
}
